export default __webpack_public_path__ + "static/beige-nr-grey-desserto-0341094f81e6f7c393c6166744bbb7d4.jpg";